import { COU_httpPost } from "@/utils/http";
import { UploadImage3 } from "@/views/moving_function/views/shipping_preview_list/bos_config";
import store from "@/store";
// 开始铺货, 根据格式化数据铺货
async function CustomMove(data) {
  const checkMall = store.state["mall_group"].checkMall;
  checkMall && (data.branchGroupRelId = checkMall.Id);
  const url = "/productMove/moveByLog";
  const r = await COU_httpPost({ url, data });
  let msg = "",
    success = false,
    result = {};
  try {
    msg = r.msg;
    success = r.success;
    result = r.result;
  } catch (error) {
    console.log(error);
  }
  if (!result) result = {};
  return { success, msg, result };
}

// 图片上传 (前端自己通过百度云sdk传到百度云上)
async function UploadImage2(file) {
  const result = await UploadImage3(file);
  return result?.imageUrl;
}

export default {
  CustomMove,
  UploadImage2,
};
